import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Rx";
import 'rxjs/Rx';
import { ApiService } from '../guards/api.service';

@Injectable()
export class ForgotPasswordService {

  constructor(private apiService: ApiService) { }

  forgotPassword(UserName) {
    return this.apiService.post('/resetcmspassword', UserName).map(data => data);
    //return this.apiService.post('/forgotpassword', UserName).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/authentication/forgot-password/forgot-password.service.ts